import { render, staticRenderFns } from "./bbzqmx.vue?vue&type=template&id=2b84adf4&scoped=true&"
import script from "./bbzqmx.vue?vue&type=script&lang=js&"
export * from "./bbzqmx.vue?vue&type=script&lang=js&"
import style0 from "./bbzqmx.vue?vue&type=style&index=0&id=2b84adf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b84adf4",
  null
  
)

export default component.exports